import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

import { Typography } from '../../../Typography';

import { isActionConfirmationModal } from '../../guards/isActionConfirmationModal';
import { useModalWrapperContext } from '../../../Modal';

const StyledDescription = styled(Typography)({
  whiteSpace: 'pre-wrap',
});

export const Description = () => {
  const { modalData } = useModalWrapperContext();
  const { t } = useI18n();

  if (!isActionConfirmationModal(modalData)) {
    return null;
  }

  const description = modalData['action-confirmation'].description;

  return (
    <StyledDescription variant="body2">
      {typeof description === 'string'
        ? t(modalData['action-confirmation'].description)
        : description}
    </StyledDescription>
  );
};
